// extracted by mini-css-extract-plugin
export default {"stickyContainer":"hfs2Gv","slideUp":"ReLh7T","classicEditorMode":"nj3rTx","hidden":"TzULrl","exiting":"_XlihR","slideDown":"nx4sf7"};